// extracted by mini-css-extract-plugin
export default {"popularCourses":"PopularCourses_popularCourses__-2ZMV","popularCourses__title":"PopularCourses_popularCourses__title__pY58A","container":"PopularCourses_container__Ugq2c"};